import gql from "graphql-tag";

export default gql`query EntityContactDetailTypeSuggestions($id:Int!, $detailTypeId:Int!) {
    entity(id:$id) {
        id
        contactDetailTypeSuggestions(detailTypeId:$detailTypeId)
    }
}`